import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, Observable, tap } from 'rxjs';
import { Note } from '../insights-data.interface';
import { ErrorHandlingService } from '../../../../../core/services/error-handling.service';
import { ApiResponse } from '../../../../../core/models/common.models';
import { environment } from '../../../../../../environments/environment.development';

@Injectable({
  providedIn: 'root',
})
export class TreatmentPhasesService {
  private readonly API_URL = `${environment.apiUrl}/BehaviorData/graph-label`;
  private labelSubject = new BehaviorSubject<ApiResponse<Note[]> | null>(null);
  labels$ = this.labelSubject.asObservable();
  constructor(
    private http: HttpClient,
    private errorHandler: ErrorHandlingService
  ) {}

  getGraphLabels(id: number): Observable<ApiResponse<Note[]>> {
    return this.http
      .get<ApiResponse<Note[]>>(`${this.API_URL}?unitId=${id}`)
      .pipe(
        tap(response => this.labelSubject.next(response)),
        catchError(error => this.errorHandler.handleError(error))
      );
  }

  deleteGraphLable(unitId: number, graphLabelId: number) {
    return this.http
      .delete<
        ApiResponse<void>
      >(`${this.API_URL}?unitId=${unitId}&graphLabelId=${graphLabelId}`, {})
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  createGraphLabel(payload: Note): Observable<ApiResponse<Note[]>> {
    return this.http
      .put<ApiResponse<Note[]>>(`${this.API_URL}`, payload)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }
}
